import { type RequestOptions, type Variables } from 'graphql-request'
import React from 'react'

import { useAuthorization } from '~/hooks/useAuthorization'
import { graphQLClient } from '~/libs/graphql-request'

export const useGraphQLRequest = () => {
  const getAuthorization = useAuthorization()

  return React.useCallback(
    async <V extends Variables = Variables, T = unknown>(
      options: RequestOptions<V, T>,
    ) =>
      await graphQLClient.request<T, V>({
        ...options,
        requestHeaders: {
          ...options.requestHeaders,
          authorization: await getAuthorization(),
        },
      }),
    [getAuthorization],
  )
}
